import { Config } from '@flowwai-frontend/shared/constants'

export const isGenerateScrutinyKeyEnabled =
   Config.ENABLE_GENERATE_SCRUTINY_KEY === 'true'

export const isFeeEngineLogsEnabled = Config.ENABLE_FEE_ENGINE_LOGS === 'true'
